const initialState = {
  build_a_portfolio_type: "",
  build_modelportfolios: [],
  backtest_data: {},
  build_histmetrics: {},
  scenario_short_list_symbols: {},
  backendParams: {
    optimization_params: {},
    fund_type: [],
    asset_class: [],
    overall_focus: [],
    styles: [],
  },
  scenario_id_based_data: {
    backtest_data: {},
    build_histmetrics: {},
    scenario_short_list_symbols: {},
  },
  reference_scenario_id_based_data: {
    backtest_data: {},
    build_histmetrics: {},
    scenario_short_list_symbols: {},
  },
  build_a_portfolio: {
    active_portfolio_id: 0,
    scenario_name: "",
    deleteSecurities: [],
    symbol_orders: {},
  },
  asset_allocation_funds: {
    active_portfolio_id: 0,
    scenario_name: "",
    allocations: {},
  },
  model_portfolios: {
    active_portfolio_id: 0,
    scenario_name: "",
    riskQuestionnaireFormData: {
      age: 0,
      dob: "",
      full_name: "",
      zip_code: "11005",
      own_house: false,
      adult_in_household: 2,
      children_in_house: 1,
      household_health: "ALL",
      industry_employed_in: "financials",
      annual_income: 100000,
      annual_expenses: 75000,
      net_worth: 250000,
      income_consistency: "guaranteed",
      investment_amount: 300000,
      investment_period: 10,
      max_loss: 10000,
    },
    questionnaireData: {},
    create_new_questionnaire_client: false,
    step: 0,
  },
  direct_review: {
    direct_review_portfolio: false,
    direct_review_orig_scenario_id: 0,
    direct_review_optimization_params: {},
    direct_review_fund_type: [],
    direct_review_asset_class: [],
    direct_review_overall_focus: [],
    direct_review_styles: [],
    direct_review_scenario_shortlist_symbols: [],
  },
};

export default function buildPortfolio(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);

  switch (type) {
    case "BUILD_A_PORTFOLIO_TYPE":
      newState.build_a_portfolio_type = payload;
      break;
    case "BUILD_SET_MODEL_PORTFOLIOS":
      newState.build_modelportfolios = payload;

      let _obj = {};
      let data = payload;
      for (let i = 0; i < data.length; i++) {
        let tempObj = {};
        tempObj["max_vol"] =
          data[i]["data"][0]["optimization_params"]["max_vol"] * 1;
        tempObj["min_return"] =
          data[i]["data"][0]["optimization_params"]["min_return"] * 1;
        tempObj["upper_bounds"] =
          data[i]["data"][0]["optimization_params"]["upper_bounds"] * 1;
        tempObj["benchmark"] =
          data[i]["data"][0]["optimization_params"]["benchmark"];

        // beta
        let _max_beta_val =
          data[i]["data"][0]["optimization_params"]["max_beta"];
        tempObj["max_beta"] =
          _max_beta_val === null ||
          _max_beta_val === undefined ||
          isNaN(_max_beta_val)
            ? 1
            : data[i]["data"][0]["optimization_params"]["max_beta"] * 1;
        // data[i]["data"][0]["optimization_params"]["max_beta"] * 1;

        _obj[data[i]["data"][0]["scenario_id"]] = tempObj;
      }
      newState.backendParams.optimization_params = _obj;
      break;
    case "BUILD_SET_SCENARIO_SHORTLIST_SYMBOLS":
      newState.scenario_short_list_symbols = payload;
      break;

    case "BUILD_SET_BACKTEST_DATA":
      newState.backtest_data = payload;
      break;

    case "BUILD_SET_HISTMETRICS":
      newState.build_histmetrics = payload;
      break;

    case "CHANGE_BUILD_A_PORTFOLIO_ACTIVE_TYPE_DATA":
      if (payload.name === "customPortfolio") {
        newState.scenario_short_list_symbols = {
          ...newState.reference_scenario_id_based_data
            .scenario_short_list_symbols,
        };
        newState.backtest_data = {
          ...newState.reference_scenario_id_based_data.backtest_data,
        };
        newState.build_histmetrics = {
          ...newState.reference_scenario_id_based_data.build_histmetrics,
        };
      } else {
        newState.scenario_short_list_symbols = {
          ...newState.scenario_id_based_data.scenario_short_list_symbols,
        };
        newState.backtest_data = {
          ...newState.scenario_id_based_data.backtest_data,
        };
        newState.build_histmetrics = {
          ...newState.scenario_id_based_data.build_histmetrics,
        };
      }

      break;
    case "BUILD_SET_ACTIVE_PORTFOLIO":
      let { activePortfolioID, group } = payload;

      if (group && group.toLowerCase() === "build_a_portfolio") {
        newState.build_a_portfolio.active_portfolio_id = activePortfolioID.toString();
      } else if (group && group.toLowerCase() === "asset_allocation_funds") {
        newState.asset_allocation_funds.active_portfolio_id = activePortfolioID.toString();
      } else if (group && group.toLowerCase() === "model_portfolios") {
        newState.model_portfolios.active_portfolio_id = activePortfolioID.toString();
      } else {
        newState.build_a_portfolio.active_portfolio_id = activePortfolioID.toString();
        newState.asset_allocation_funds.active_portfolio_id = activePortfolioID.toString();
        newState.model_portfolios.active_portfolio_id = activePortfolioID.toString();
      }

      let activeData =
        newState.build_modelportfolios &&
        newState.build_modelportfolios.length > 0 &&
        newState.build_modelportfolios.filter(
          (e) => e.id === activePortfolioID
        )[0]["data"][0];

      newState.backendParams.fund_type = activeData && activeData.fund_type;

      newState.backendParams.asset_class = activeData && activeData.asset_class;
      //.filter((d) => d.name !== "Cash");
      newState.backendParams.overall_focus =
        activeData && activeData.overall_focus;
      // .filter(
      //   (d) => d.name !== "Cash"
      // );
      newState.backendParams.styles = activeData && activeData.styles;
      //.filter((d) => d.style !== "Cash");

      // reset delete securities list
      newState.build_a_portfolio.deleteSecurities = [];
      break;

    case "BUILD_SET_SCENARIO_NAME":
      let { scenario_name } = payload;

      if (
        payload.group &&
        payload.group.toLowerCase() === "build_a_portfolio"
      ) {
        newState.build_a_portfolio.scenario_name = scenario_name;
      } else if (
        payload.group &&
        payload.group.toLowerCase() === "asset_allocation_funds"
      ) {
        newState.asset_allocation_funds.scenario_name = scenario_name;
      } else if (
        payload.group &&
        payload.group.toLowerCase() === "model_portfolios"
      ) {
        newState.model_portfolios.scenario_name = scenario_name;
      }
      break;

    case "BUILD_COMMON_DUAL_SLIDER_HANDLER":
      let { min, max, name } = payload;
      // get--- min,max,group,name
      // name - indivaidual slide name / style
      // group - asset_class, overall_focus etc
      let slider_group_data = newState.direct_review.direct_review_portfolio
        ? newState.direct_review[payload.group]
        : newState.backendParams[payload.group];

      let slider_group_new_data;

      if (
        payload.group.toLowerCase() === "styles" ||
        payload.group.toLowerCase() === "style"
      ) {
        let list = [
          {
            style: name,
            min: (min / 100).toString(),
            max: (max / 100).toString(),
          },
        ];
        slider_group_new_data = slider_group_data.map(
          (obj) => list.find((o) => o.style === obj.style) || obj
        );
      } else {
        let list = [
          {
            name: name,
            min: (min / 100).toString(),
            max: (max / 100).toString(),
          },
        ];
        slider_group_new_data = slider_group_data.map(
          (obj) => list.find((o) => o.name === obj.name) || obj
        );
      }

      if (newState.direct_review.direct_review_portfolio) {
        newState.direct_review[payload.group] = slider_group_new_data;
      } else {
        newState.backendParams[payload.group] = slider_group_new_data;
      }

      break;

    case "COMMON_TUNERS_HANDLER":
      if (
        newState.backendParams.optimization_params &&
        Object.keys(newState.backendParams.optimization_params).includes(
          payload.id
        ) &&
        Object.keys(newState.backendParams.optimization_params).length > 0 &&
        newState.direct_review.direct_review_portfolio === false
      ) {
        let _clone_optimization_params = {
          ...newState.backendParams.optimization_params,
        };
        _clone_optimization_params[payload.id][payload.type] = +payload.value;

        newState.backendParams.optimization_params = _clone_optimization_params;
      } else if (
        newState.direct_review.direct_review_portfolio &&
        Object.keys(newState.direct_review.direct_review_optimization_params)
          .length > 0
      ) {
        let _clone_optimization_params = {
          ...newState.direct_review.direct_review_optimization_params,
        };
        _clone_optimization_params[payload.id][payload.type] = +payload.value;

        newState.direct_review.direct_review_optimization_params = _clone_optimization_params;
      }
      break;

    case "BUILD_A_PORTFOLIO_LIST_OF_SECURITIES_TO_DELETE":
      if (
        newState.build_a_portfolio.deleteSecurities.includes(payload) === false
      ) {
        newState.build_a_portfolio.deleteSecurities.push(payload);
      }
      break;
    case "BUILD_A_PORTFOLIO_LIST_OF_SECURITIES_TO_DELETE_UNDO":
      let _undo_delete_securities = [
        ...newState.build_a_portfolio.deleteSecurities,
      ];
      let filtered_securities = _undo_delete_securities.filter(
        (symbol) => payload !== symbol
      );
      newState.build_a_portfolio.deleteSecurities = filtered_securities;
      break;

    case "BUILD_A_PORTFOLIO_SET_ALLOCATION":
      if (newState.direct_review.direct_review_portfolio) {
        newState.direct_review.direct_review_scenario_shortlist_symbols.forEach(
          function (part, index, theArray) {
            if (theArray[index]["symbol"] == payload.symbol) {
              theArray[index]["val"] = payload.value;
            }
          }
        );
      } else {
        newState.scenario_short_list_symbols[
          newState.build_a_portfolio.active_portfolio_id
        ].forEach(function (part, index, theArray) {
          if (theArray[index]["symbol"] == payload.symbol) {
            theArray[index]["val"] = payload.value;
          }
        });
      }

      break;
    case "BUILD_A_PORTFOLIO_SYMBOLS_ORDER":
      newState.build_a_portfolio.symbol_orders = payload;
      break;
    case "BUILD_A_PORTFOLIO_RESET":
      newState.build_a_portfolio.active_portfolio_id = 0;
      newState.asset_allocation_funds.active_portfolio_id = 0;
      newState.model_portfolios.active_portfolio_id = 0;
      // newState.backendParams.optimization_params = {};
      break;

    case "BUILD_A_PORTFOLIO_CREATE_NEW_QUESTIONNAIRE_CLIENT":
      newState.model_portfolios.create_new_questionnaire_client = payload;
      break;

    case "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE":
      newState.model_portfolios.questionnaireData = payload;
      break;
    case "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA":
      newState.model_portfolios.riskQuestionnaireFormData[payload.name] =
        payload.value;
      break;
    case "RESET_BUILD_A_PORTFOLIO_QUESTIONNAIRE_STEP_AND_NEWCLIENTACTIVE":
      newState.model_portfolios.create_new_questionnaire_client = false;
      newState.model_portfolios.step = 0;
      break;
    case "RESET_BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA":
      newState.model_portfolios.riskQuestionnaireFormData.age = 0;
      newState.model_portfolios.riskQuestionnaireFormData.dob = "";
      newState.model_portfolios.riskQuestionnaireFormData.full_name = "";
      newState.model_portfolios.riskQuestionnaireFormData.zip_code = "";
      newState.model_portfolios.riskQuestionnaireFormData.own_house = false;
      newState.model_portfolios.riskQuestionnaireFormData.adult_in_household = 0;
      newState.model_portfolios.riskQuestionnaireFormData.children_in_house = 0;
      newState.model_portfolios.riskQuestionnaireFormData.household_health = "";
      newState.model_portfolios.riskQuestionnaireFormData.industry_employed_in =
        "";
      newState.model_portfolios.riskQuestionnaireFormData.annual_income = 0;
      newState.model_portfolios.riskQuestionnaireFormData.annual_expenses = 0;
      newState.model_portfolios.riskQuestionnaireFormData.net_worth = 0;
      newState.model_portfolios.riskQuestionnaireFormData.income_consistency =
        "";
      newState.model_portfolios.riskQuestionnaireFormData.investment_amount = 0;
      newState.model_portfolios.riskQuestionnaireFormData.investment_period = 0;
      newState.model_portfolios.riskQuestionnaireFormData.max_loss = 0;
      break;

    case "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA_EDIT":
      newState.model_portfolios.riskQuestionnaireFormData.age = payload.age;
      newState.model_portfolios.riskQuestionnaireFormData.dob = payload.dob;
      newState.model_portfolios.riskQuestionnaireFormData.full_name =
        payload.full_name;
      newState.model_portfolios.riskQuestionnaireFormData.zip_code =
        payload.zip_code;
      newState.model_portfolios.riskQuestionnaireFormData.own_house =
        payload.own_house;
      newState.model_portfolios.riskQuestionnaireFormData.adult_in_household =
        payload.adult_in_household;
      newState.model_portfolios.riskQuestionnaireFormData.children_in_house =
        payload.children_in_house;
      newState.model_portfolios.riskQuestionnaireFormData.household_health =
        payload.household_health;
      newState.model_portfolios.riskQuestionnaireFormData.industry_employed_in =
        payload.industry_employed_in;
      newState.model_portfolios.riskQuestionnaireFormData.annual_income =
        payload.annual_income;
      newState.model_portfolios.riskQuestionnaireFormData.annual_expenses =
        payload.annual_expenses;
      newState.model_portfolios.riskQuestionnaireFormData.net_worth =
        payload.net_worth;
      newState.model_portfolios.riskQuestionnaireFormData.income_consistency =
        payload.income_consistency;
      newState.model_portfolios.riskQuestionnaireFormData.investment_amount =
        payload.investment_amount;
      newState.model_portfolios.riskQuestionnaireFormData.investment_period =
        payload.investment_period;
      newState.model_portfolios.riskQuestionnaireFormData.max_loss =
        payload.max_loss;
      break;

    case "BUILD_A_PORTFOLIO_SET_MODEL_PORTFOLIO_STEP":
      newState.model_portfolios.step = payload;
      break;
    case "BUILD_A_PORTFOLIO_SET_ALLOCATION_FUNDS_ALLOCATION":
      newState.asset_allocation_funds.allocations = payload;
      break;

    case "BUILD_A_PORTFOLIO_SET_ALLOCATION_FUNDS_ALLOCATION_VALUES":
      let _allocation = { ...newState.asset_allocation_funds.allocations };

      _allocation[payload.id] = payload.value * 1;

      newState.asset_allocation_funds.allocations = _allocation;
      break;

    case "BUILD_SET_SCENARIO_ID_BASED_DATA":
      newState.scenario_id_based_data = {
        ...newState.scenario_id_based_data,
        [payload.key]: payload.obj,
      };
      break;
    case "BUILD_SET_REFERENCE_SCENARIO_ID_BASED_DATA":
      newState.reference_scenario_id_based_data = {
        ...newState.reference_scenario_id_based_data,
        [payload.key]: payload.obj,
      };
      break;

    case "BUILD_DIRECT_REVIEW_PORTFOLIO":
      newState.direct_review.direct_review_orig_scenario_id = payload.orig_id;
      newState.direct_review.direct_review_scenario_id = payload.scenario_id;
      newState.direct_review.direct_review_portfolio = payload.status;
      newState.direct_review.direct_review_optimization_params =
        payload.optimization_params;
      newState.direct_review.direct_review_asset_class = payload.asset_class;
      newState.direct_review.direct_review_fund_type = payload.fund_type;
      newState.direct_review.direct_review_overall_focus =
        payload.overall_focus;
      newState.direct_review.direct_review_styles = payload.styles;

      break;
    case "BUILD_DIRECT_REVIEW_PORTFOLIO_SHORTLIST":
      newState.direct_review.direct_review_scenario_shortlist_symbols =
        payload.shortlist_symbols;
      break;
    case "RESET_BUILD_A_PORTFOLIO_MODEL_PORTFOLIO":
      newState.model_portfolios.active_portfolio_id = 0;
      newState.model_portfolios.scenario_name = "";
      break;
    case "RESET_BUILD_A_PORTFOLIO_ALLOCATIONS_FUNDS":
      newState.asset_allocation_funds.allocations = {};
      newState.asset_allocation_funds.scenario_name = "";
      break;
    case "RESET_BUILD_A_PORTFOLIO":
      newState.backendParams.optimization_params = {};
      newState.backendParams.fund_type = [];
      newState.backendParams.asset_class = [];
      newState.backendParams.overall_focus = [];
      newState.backendParams.styles = [];
      newState.build_histmetrics = {};
      newState.backtest_data = {};
      newState.build_modelportfolios = [];
      newState.scenario_short_list_symbols = {};
      newState.build_a_portfolio.active_portfolio_id = 0;
      newState.build_a_portfolio.scenario_name = "";

      newState.model_portfolios.active_portfolio_id = 0;
      newState.model_portfolios.scenario_name = "";
      newState.model_portfolios.step = 0;
      newState.model_portfolios.questionnaireData = {};

      newState.build_a_portfolio_type = "";
      newState.build_a_portfolio.deleteSecurities = [];
      newState.build_a_portfolio.symbol_orders = {};

      newState.reference_scenario_id_based_data.scenario_short_list_symbols = {};
      newState.reference_scenario_id_based_data.backtest_data = {};
      newState.reference_scenario_id_based_data.build_histmetrics = {};

      newState.scenario_id_based_data.scenario_short_list_symbols = {};
      newState.scenario_id_based_data.backtest_data = {};
      newState.scenario_id_based_data.build_histmetrics = {};

      newState.direct_review.direct_review_orig_scenario_id = 0;
      newState.direct_review.direct_review_scenario_id = 0;
      newState.direct_review.direct_review_portfolio = false;

      break;
    case "RESET_BUILD_A_PORTFOLIO_ACTIVE_ID":
      newState.build_a_portfolio.active_portfolio_id = 0;
      newState.model_portfolios.active_portfolio_id = 0;
      newState.model_portfolios.symbol_orders = {};
      newState.build_a_portfolio.deleteSecurities = [];
      newState.build_a_portfolio.symbol_orders = {};
      break;

    case "RESET_BUILD_DIRECT_REVIEW":
      if (newState.direct_review.direct_review_portfolio) {
        newState.build_modelportfolios = [];
      }
      newState.direct_review.direct_review_orig_scenario_id = 0;
      newState.direct_review.direct_review_scenario_id = 0;
      newState.direct_review.direct_review_portfolio = false;
      newState.direct_review.direct_review_optimization_params = {};
      newState.direct_review.direct_review_fund_type = [];
      newState.direct_review.direct_review_asset_class = [];
      newState.direct_review.direct_review_overall_focus = [];
      newState.direct_review.direct_review_styles = [];
      newState.direct_review.direct_review_scenario_shortlist_symbols = [];
      break;
    default:
      break;
  }
  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/buildPortfolio.reducer.js